
let index = () => import('@/views/homePage/index.vue')

export default [
  { path: '/', redirect: '/index' },
  { path: '/index', name: 'index', component: index, meta: { isLogin: false } }
]



// WEBPACK FOOTER //
// ./src/router/homePage/index.js